var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 4.29289C5.68342 3.90237 6.31658 3.90237 6.70711 4.29289L12.2929 9.87868L17.8787 4.29289C18.2692 3.90237 18.9024 3.90237 19.2929 4.29289C19.6834 4.68342 19.6834 5.31658 19.2929 5.70711L13.7071 11.2929L19.2929 16.8787C19.6834 17.2692 19.6834 17.9024 19.2929 18.2929C18.9024 18.6834 18.2692 18.6834 17.8787 18.2929L12.2929 12.7071L6.70711 18.2929C6.31658 18.6834 5.68342 18.6834 5.29289 18.2929C4.90237 17.9024 4.90237 17.2692 5.29289 16.8787L10.8787 11.2929L5.29289 5.70711C4.90237 5.31658 4.90237 4.68342 5.29289 4.29289Z",
    fill: "currentColor"
  })));
}

export default SvgClose;